// extracted by mini-css-extract-plugin
export var cardContainer = "_pd-0";
export var cardHeader = "_pd-2";
export var collapsedState = "_pd-3";
export var dragHandle = "_pd-5";
export var dragHandleIcon = "_pd-6";
export var dragging = "_pd-1";
export var titleArea = "_pd-4";